import { TOpenModal } from '@apia/components';
import { Collector } from './Collector';
import { CollectorField } from './CollectorField';
import { ValidatedCollectorField } from './ValidatedCollectorField';
import { validationsStore } from '../validationStore';

export class WithMemoryCollector extends Collector {
  constructor(protected prefix: string) {
    super();
  }

  private memoized = new Set<string>();
  private getKey(name: string) {
    return `[WithMemoryCollector]${this.prefix}__${name}`;
  }

  addMemoized(...fields: CollectorField[]) {
    for (const f of fields) {
      let initialValue: any = undefined;

      if (f instanceof ValidatedCollectorField) {
        this.memoized.add(f.name);

        const stored = localStorage.getItem(this.getKey(f.name));

        if (stored) {
          initialValue = JSON.parse(stored);
        }
      }

      super.add(f);

      if (initialValue !== undefined) {
        validationsStore.setFieldValue(this.id, f.name, initialValue);
      }
    }

    return this;
  }

  async show<FormValues extends Record<string, unknown>>(
    modalProps?: Partial<
      Omit<TOpenModal, 'children' | 'onConfirm' | 'onCancel' | 'confirmProps'>
    > &
      Partial<{
        hideConfirm: boolean;
        onConfirm?: (res: FormValues | null) => boolean;
      }>,
  ) {
    const res = await super.show(modalProps);

    if (res) {
      for (const f of Object.values(this.fieldsStore)) {
        if (f instanceof ValidatedCollectorField && this.memoized.has(f.name)) {
          if (f.value !== undefined) {
            localStorage.setItem(this.getKey(f.name), JSON.stringify(f.value));
          }
        }
      }
    }

    return res;
  }
}
